import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-16 md:py-20 px-4" data-id="element-91">
      <div className="container mx-auto max-w-2xl" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-green-50 rounded-2xl p-8 md:p-12 border-2 border-green-200 text-center" data-id="element-93">
          <ShieldCheck className="w-16 h-16 text-green-600 mx-auto mb-6" data-id="element-94" />
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-4" data-id="element-95">
            🔒 Garantía sin riesgo
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-96">
            Probalo durante 7 días. Si no sentís claridad y avance real, te
            devolvemos el 100% del dinero. Sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}